import { createContext } from 'react';

export const SubDrawerContext = createContext<{
  id?: string;
  isActive: boolean;
}>({
  isActive: false,
});
